import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'

import importProducts from './importProducts/index.vue';
import importOrders from './importOrders/index.vue';
import importPO from './importPO/index.vue';
import importRackID from './importRackID/index.vue';
import importSR from './importSR/index.vue';
import importMoveOrders from './importMoveOrders/index.vue';
import VOffline from 'v-offline';
import DetectedSpeed from 'vue-identify-network';

export default {
	name: 'vendor-company-master',
	components: {
		DatePicker,
		'First': importProducts,
		'Second': importOrders,
		'Third': importPO,
		'fourth': importRackID,
		'fifth': importSR,
		'sixth': importMoveOrders,
		VOffline,
		DetectedSpeed
	},
	props: [],
	data() {
		return {
			currentTab: 'First',
			componentKey: 0,
			tabs: [{
					key: 'First',
					value: (this.$t('productLogReport.importProducts'))
				},
				{
					key: 'Second',
					value: (this.$t('productLogReport.importOrders'))
				},
				{
					key: 'Third',
					value: (this.$t('productLogReport.importPOs'))
				},
				{
					key: 'fourth',
					value: (this.$t('productLogReport.importRacks'))
				},
				{
					key: 'fifth',
					value: (this.$t('productLogReport.importSr'))
				},
				{
					key: 'sixth',
					value: (this.$t('productLogReport.importMoveOrders'))
				},
			],
			onLine: true,
			speed: 0,
			networkType: null
		}
	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	mounted() {},
	methods: {
		// handleNetworkIdentified(type) {
		// 	this.networkType = type
		// },
		// handleNetworkSpeed(speed) {
		// 	this.speed = speed
		// },
		// amIOnline(e) {
		// 	this.onLine = e;
		// },
	}
}


// WEBPACK FOOTER //
// ./src/views/components/importCSV/importcsv.component.js